var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.152,
    height: 19.153,
    viewBox: "0 0 19.152 19.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M959.353,2004.773,954.58,2000l-3.58,3.58,5.787,5.608a7.637,7.637,0,0,1,2.506-4.3l.06-.119ZM961.74,2000l2.506,2.506-3.7,3.7a6.752,6.752,0,0,0-2.387,5.787v7.16h4.773v-7.16a3.245,3.245,0,0,1,1.014-2.386l3.7-3.7,2.506,2.506v-8.353l-8.413-.06Z",
    transform: "translate(-951 -2000)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.a4ec0b7b.svg";
export { ForwardRef as ReactComponent };